import { initModals } from "flowbite";
import React, { useEffect } from "react";
import { useState } from "react";
import WalletConnect from "../WalletConnect";
import { ChangePage } from "../../store/reducers/menu";
import { useDispatch, useSelector } from "../../store";

export default function WalletModal() {
  const dispatch = useDispatch();
  const [currency, setCurrency] = useState({});
  const { balances } = useSelector((store) => store.auth);
  const [tabIndex, setTabIndex] = useState(0);

  const setNowCurrency = () => {
    if (balances.length > 0) {
      balances.map((item) => {
        if (item.status) {
          setCurrency(item.currency);
        }
      });
    }
  }

  useEffect(() => {
    setNowCurrency();
  });

  return (
    <>
      <div
        id="wallet-modal"
        tabIndex={-1}
        style={{ backgroundColor: "rgba(22,22,22,0.8)" }}
        aria-hidden="true"
        className="flex justify-center items-center fixed top-0 left-0 right-0 z-50 w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-screen "
      >
        <div className="relative w-full max-w-xl">
          {/* Modal content */}
          <div className="relative bg-white rounded-lg shadow dark:bg-black">
            <button
              type="button"
              className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
              onClick={() => dispatch(ChangePage(''))}
            >
              <svg
                className="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
                />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
            <div className="px-6 py-6 lg:px-8">
              <div className="flex flex-row items-center gap-2">
                <img src={currency.icon} className="w-6 h-6 m-0 p-0" />
                <p className="text-lg text-white font-bold">{currency.name}</p>
                <p className="text-lg text-white font-bold">({currency.network})</p>
              </div>
              {/* <li className="mr-2">
                  <button
                    onClick={() => {
                      setTabIndex(1);
                    }}
                    className={`inline-block px-4 py-3 rounded-lg  ${tabIndex === 1
                      ? "text-white bg-yellow-400 active"
                      : "hover:text-gray-900 hover:bg-gray-100 dark:hover:bg-gray-800 dark:hover:text-white"
                      }`}
                  >
                    Withdraw
                  </button>
                </li> */}
              <WalletConnect />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
